import { logsApi } from '@/admin/api/logs';
import { queryOptions } from '@tanstack/react-query';

export const logsQuery = () =>
	queryOptions({
		queryKey: ['logs'] as const,
		queryFn: () => logsApi.get(500),
		staleTime: 10_000,
		refetchOnWindowFocus: true,
	});
